import { useAuthStore } from '../../../stores/auth';

/** Role lớp 1 của Keycloak, và nhãn nội bộ `lib/auth/oidc.ts` gắn cho tài khoản đó. */
const ROLE_QUAN_TRI_TO_CHUC = 'TENANT_ADMIN';
const NHAN_QUAN_TRI_TO_CHUC = 'vaiTro.quanTriToChuc';

/**
 * Người này có phải quản trị tổ chức không.
 *
 * Hồ sơ nhận diện kiểm theo **vai trò** `TENANT_ADMIN`, đúng như tenant-service
 * (`Caller.tenantAdmin()`, như khoá API ở ADR-0068) — không kiểm theo mã quyền
 * phân hệ. Lý do: ở cổng tenant, quyền `<PHÂN_HỆ>.<HÀNH_ĐỘNG>` do giao diện tự
 * suy từ bản đồ đường dẫn (`tinhQuyenCongTenant`), mà tab này không phải một
 * đường dẫn nên sẽ không bao giờ nhận được mã quyền riêng.
 *
 * Chỉ là việc ẩn/hiện. Server kiểm lại ở mọi endpoint ghi.
 */
export function useQuanTriToChuc(): boolean {
  return useAuthStore(
    (s) =>
      (s.user?.vaiTroLop1?.includes(ROLE_QUAN_TRI_TO_CHUC) ?? false) ||
      (s.user?.roles.includes(NHAN_QUAN_TRI_TO_CHUC) ?? false),
  );
}
